import { supabase } from './supabase';

const PAGE_SIZE = 1000;

/**
 * Pagina uma RPC anon que retorna SETOF (sujeita ao limite "Max Rows" do
 * PostgREST — 1000 por padrão no projeto). Chama via GET
 * (`supabase.rpc(fn, args, { get: true })`) porque o PostgREST só honra o
 * cabeçalho Range em requisições GET, não em POST, e itera com `.range()`
 * até uma página vir menor que PAGE_SIZE.
 */
export async function fetchAllRpcPages<T>(
  fn: string,
  args: Record<string, unknown>,
): Promise<T[]> {
  const result: T[] = [];
  let from = 0;
  while (true) {
    const { data, error } = await supabase
      .rpc(fn as never, args as never, { get: true })
      .range(from, from + PAGE_SIZE - 1);
    if (error) throw error;
    const page = (data ?? []) as unknown as T[];
    result.push(...page);
    if (page.length < PAGE_SIZE) break;
    from += PAGE_SIZE;
  }
  return result;
}
